<script setup lang="ts">

//vue
import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

//services
import * as service from "@/services/clienteService";
import storeControle from "@/utils/storeControle";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";

const router = useRouter();
const route = useRoute();

var controle = reactive({
  clienteId: 0 as number | null,
  senha: "",
  model: {} as service.ClienteLogin,
  status: "" as string,
  erro: "" as string
})

onMounted(() => {

  console.log("Query Params:", route.query);
  controle.clienteId = route.query["clienteId"] ? Number(route.query["clienteId"]) : null
  controle.senha = route.query["senha"] ? String(route.query["senha"]) : ""

  if (controle.clienteId && controle.senha) {
    controle.model.cpf = String(controle.clienteId);
    controle.model.senha = String(controle.senha);
    login();
  }

});

function login() {

  // Lógica de login aqui
  console.log("Realizando login para o clienteId:", controle.clienteId);
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  var param = { clienteId: controle.clienteId, senha: controle.senha } as service.ClienteLoginExterno
  service.loginExterno(param)
    .then((response) => {

       if (response.accessToken) {
          localStorage.setItem('user', JSON.stringify(response));
          storeControle.token = getToken();
          storeControle.usuario = response;
          controle.status = "Login realizado com sucesso! Redirecionando...";
          controle.erro = "";
        }

        setTimeout(() => {
          router.push({ name: "PainelCliente" });
        }, 3000);
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || error;
    });
}


</script>
<template>


  <div class="row">

    <div class="col-md-3">

    </div>

    <div class="col-md-6">

      <div class="row">
        <div class="col-md-12 text-center mb-5 mt-5">
          <img :src="imgLogin" alt="Login do Cliente" class="img-fluid">
        </div>

        <div class="col-md-12 text-center">
          <h2 class="mt-4 mb-3">Área do Cliente</h2>
        </div>

        <div class="col-md-12 text-center">
          <h3 class="mt-4 mb-3">Login automático</h3>
        </div>

        
      </div>

      <div class="row">

        <div class="col-md-12 mb-3">

          <div class="mt-3 text-primary text-center" v-if="controle.erro == ''">
            {{ controle.status }}
          </div>

          <div class="mt-3 text-danger text-center" v-if="controle.erro != ''">
            {{ controle.erro }}
          </div>
        </div>
      </div>

      <div class="col-md-3">

      </div>
      </div>
    </div>
</template>